import React from 'react';
import { connect } from 'react-redux';
import OurTool from './index';

class OurToolContainer extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }
  render() {
    return (
      <OurTool language={this.props.language} />
    )
  }
}

function mapStateToProps(state) {
  return {
    language: state.preference.language,
  }
}

export default connect(mapStateToProps)(OurToolContainer);


// WEBPACK FOOTER //
// ./src/pages/OurTool/container.js